'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialMessageStaged = undefined;

var _reduxActions = require('redux-actions');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var initialMessageStaged = exports.initialMessageStaged = (0, _reduxActions.createAction)(_VisitorActionTypes.INITIAL_MESSAGE_STAGED);


//////////////////
// WEBPACK FOOTER
// ./js/actions/ConversationsActions/initialMessageStaged.js
// module id = 931
// module chunks = 2 3